module.exports = __webpack_public_path__ + "img/2025-fusion-anaïs.97c91b0.jpg";